import React, { useState, useEffect } from 'react';
import { MailCheck, X, AlertCircle } from 'lucide-react';
import { __ } from './translations';

/**
 * Component to display notification about new users being added to a company
 * and the status of the welcome emails that were sent to them.
 */
const UserInvitationNotification = ({ emailResults, onDismiss }) => {
  const [visible, setVisible] = useState(true);

     
  console.log('UserInvitationNotification rendering with:', { 
    emailResults, 
    visible,
    hasDetails: emailResults?.details?.length > 0 
  });

  // Check why we might not render and log it
  if (!visible) {
    console.log('Not rendering: visible is false');
    return null;
  }
  
  if (!emailResults) {
    console.log('Not rendering: emailResults is null/undefined');
    return null;
  }
  
  if (!emailResults.details || emailResults.details.length === 0) {
    console.log('Not rendering: no details in emailResults');
    return null;
  }

  // Automatically hide the notification after 10 seconds
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (onDismiss) onDismiss();
      }, 10000);
      
      return () => clearTimeout(timer);
    }
  }, [visible, onDismiss]);
    
    // In UserInvitationNotification.tsx
useEffect(() => {
    console.log('UserInvitationNotification props:', { 
        visible, 
        emailResults,
        hasDetails: emailResults && emailResults.details && emailResults.details.length > 0 
    });
}, [visible, emailResults]);

  const handleDismiss = () => {
    setVisible(false);
    if (onDismiss) onDismiss();
  };

  if (!visible || !emailResults || !emailResults.details || emailResults.details.length === 0) {
    return null;
  }

  const { sent, failed, details } = emailResults;
  const allSuccess = failed === 0;
  const allFailed = sent === 0;
  
  // Determine notification styling based on success/failure
  const bgColor = allSuccess ? "bg-green-50" : allFailed ? "bg-red-50" : "bg-yellow-50";
  const borderColor = allSuccess ? "border-green-400" : allFailed ? "border-red-400" : "border-yellow-400";
  const icon = allSuccess ? (
    <MailCheck className="h-5 w-5 text-green-500" />
  ) : (
    <AlertCircle className="h-5 w-5 text-red-500" />
  );
  
  return (
    <div className={`rounded-md ${bgColor} p-4 mb-6 border-l-4 ${borderColor}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          {icon}
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-gray-800">
            {allSuccess
              ? __('Welcome emails sent successfully')
              : allFailed
              ? __('Failed to send welcome emails')
              : __('Some welcome emails were sent')}
          </h3>
          <div className="mt-2 text-sm text-gray-700">
            <p>
              {sent > 0 && (
                <span>
                  {sent} {sent === 1 ? __('email was') : __('emails were')} {__('sent successfully.')} {' '}
                </span>
              )}
              {failed > 0 && (
                <span className="text-red-600">
                  {failed} {failed === 1 ? __('email failed') : __('emails failed')} {__('to send.')}
                </span>
              )}
            </p>
            {/* Only show details if there are failures */}
            {failed > 0 && (
              <ul className="mt-2 list-disc pl-5 space-y-1">
                {details
                  .filter(detail => detail.status === 'failed')
                  .map((detail, index) => (
                    <li key={index}>
                      {detail.email}: {detail.message}
                    </li>
                  ))}
              </ul>
            )}
          </div>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              type="button"
              onClick={handleDismiss}
              className="inline-flex rounded-md p-1.5 text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-gray-600"
            >
              <span className="sr-only">{__('Dismiss')}</span>
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserInvitationNotification;